import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsRepresCondPagtoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/repres-cond-pagto');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/repres-cond-pagto', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pic Regra');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/repres-cond-pagto', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pic Regra');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/repres-cond-pagto/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pic Regra');
    }
  }

  async update(data) {
    // console.log(data);
    try {
      const { data: response } = await this.api.post('/repres-cond-pagto/update/', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pic Regra');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/repres-cond-pagto/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pic Regra');
    }
  }
}
